import React, { useEffect, useState } from "react";
import {
  Spin,
  Button,
  Row,
  Col,
  Input,
  Space,
  Card,
  Typography,
  Select,
  DatePicker,
} from "antd";
import { ArrowRight, Medal, Search } from "lucide-react";
import { FONT } from "constants/index";
import { notificationErroInternal } from "util/api-utils";
import { ColumnsUserBoot } from "./columns-table";
import DrawerApp from "components/drawer-app";
import { getUsersBoot } from "services/boot/boot-service";
import FormTrainningBootAqua from "./trainning-drawer-boot-aqua";
import useBreakpoint from "hooks/useBreakpoint";
import { drawerWidth, listMinWidth } from "util/responsive";
import ResponsiveDataList from "components/responsive-data-list";

const { Text } = Typography;
const { RangePicker } = DatePicker;

const levels = [
  { label: "APERFEIÇOAMENTO", value: "APERFEIÇOAMENTO" },
  { label: "CONDICIONAMENTO", value: "CONDICIONAMENTO" },
  { label: "INICIAÇÃO", value: "INICIAÇÃO" },
];

const TrainningBootAqua = () => {
  const { isMobile } = useBreakpoint();
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState(null);
  const [data, setData] = useState([]);
  const [editId, setEditId] = useState(null);
  const [openDetail, setOpenDetail] = useState(false);
  const [level, setLevel] = useState([]);
  const [dateRange, setDateRange] = useState(null);

  useEffect(() => {
    refreshData();
  }, []);

  function refreshData() {
    setLoading(true);
    getData();
  }

  function getData() {
    let start = null;
    let end = null;
    if (dateRange && dateRange[0] && dateRange[1]) {
      start = dateRange[0].format("YYYY-MM-DDTHH:mm:ss-03:00");
      end = dateRange[1].format("YYYY-MM-DDTHH:mm:ss-03:00");
    }

    let obj = {
      search: search,
      level: level,
      start: start,
      end: end,
    };

    obj = Object.fromEntries(
      Object.entries(obj).filter(
        ([key, value]) => value !== undefined && value != "" && value != null
      )
    );
    getUsersBoot(obj)
      .then((res) => {
        res = res.map((obj) => ({
          ...obj,
          detail: detail,
        }));
        setLoading(false);
        setData(res);
      })
      .catch(() => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const mountFilter = () => (
    <Row
      className="reviews-filter-row"
      gutter={[16, 16]}
      style={{ padding: "10px", alignItems: "center" }}
    >
      <Col xs={24} md={12} lg={8}>
        <Input
          allowClear
          value={search ?? ""}
          placeholder="Pesquisar Aluno"
          onChange={(e) => setSearch(e.target.value)}
          prefix={<Search size={18} color="#e0e0e0" />}
          style={{ width: "100%" }}
          onPressEnter={refreshData}
        />
      </Col>
      <Col xs={24} md={12} lg={6}>
        <Select
          allowClear
          mode="multiple"
          placeholder="Nível"
          options={levels}
          value={level}
          onChange={setLevel}
          style={{ width: "100%" }}
        />
      </Col>
      <Col xs={24} md={12} lg={6}>
        <RangePicker
          value={dateRange}
          onChange={setDateRange}
          style={{ width: "100%" }}
        />
      </Col>
      <Col xs={24} md={6} lg={4}>
        <Button
          style={{ fontFamily: FONT, width: "100%" }}
          type="primary"
          icon={
            <ArrowRight
              size={18}
              style={{ marginBottom: "-3px", marginRight: "7px" }}
            />
          }
          onClick={refreshData}
        >
          Filtrar
        </Button>
      </Col>
    </Row>
  );

  const onCloseDetail = () => {
    setOpenDetail(false);
    setEditId(null);
    refreshData();
  };
  const showDrawerDetail = () => {
    setOpenDetail(true);
  };

  function detail(row) {
    setEditId(row.id);
    showDrawerDetail();
  }

  return (
    <div className="container-trainning">
      <Spin size="large" spinning={loading}>
        {mountFilter()}
        <Row gutter={[24, 24]} style={{ marginLeft: "0px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{
              flex: "1 1 500px",
              minWidth: listMinWidth(isMobile),
            }}
          >
            <Card
              id="card-table"
              className="card-table-list"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <Medal
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                      Treino dos Alunos
                    </Text>
                  </div>
                </div>
              }
              bordered={false}
            >
              <ResponsiveDataList
                isMobile={isMobile}
                forceCardLayout
                cardVariant="profile"
                rowKey={"id"}
                columns={ColumnsUserBoot()}
                dataSource={data}
                pagination={{ pageSize: 10, showSizeChanger: false }}
                locale={{
                  emptyText: "Sem registro",
                }}
              />
            </Card>
          </Space>
        </Row>
      </Spin>

      <DrawerApp
        open={openDetail}
        onClose={onCloseDetail}
        title={"Progresso"}
        body={
          <FormTrainningBootAqua
            user={data.find((item) => item.id == editId)}
          />
        }
        size={"large"}
        isOnlyView={true}
        width={drawerWidth(isMobile, 60)}
      />
    </div>
  );
};
export default TrainningBootAqua;
